const personalization = {
    matrix: [
        { group: 'all', price: 'any_price', like: 'stylish', no: 1222 },
        { group: 'all', price: 'any_price', like: 'handmade', no: 1122 },
        { group: 'all', price: 'under_25', like: 'stylish', no: 659 },
        { group: 'all', price: 'under_25', like: 'handmade', no: 640 },
        { group: 'all', price: '25_50', like: 'stylish', no: 276 },
        { group: 'all', price: '25_50', like: 'handmade', no: 223 },
        { group: 'all', price: '50_100', like: 'stylish', no: 216 },
        { group: 'all', price: '50_100', like: 'handmade', no: 172 },
        { group: 'all', price: 'over_100', like: 'stylish', no: 30 },
        { group: 'all', price: 'over_100', like: 'handmade', no: 33 },
        { group: 1, price: 'any_price', like: 'stylish', no: 0 },
        { group: 1, price: 'any_price', like: 'handmade', no: 5 },
        { group: 1, price: 'under_25', like: 'stylish', no: 0 },
        { group: 1, price: 'under_25', like: 'handmade', no: 5 },
        { group: 1, price: '25_50', like: 'stylish', no: 0 },
        { group: 1, price: '25_50', like: 'handmade', no: 0 },
        { group: 1, price: '50_100', like: 'stylish', no: 0 },
        { group: 1, price: '50_100', like: 'handmade', no: 0 },
        { group: 1, price: 'over_100', like: 'stylish', no: 0 },
        { group: 1, price: 'over_100', like: 'handmade', no: 0 },
        { group: 2, price: 'any_price', like: 'stylish', no: 380 },
        { group: 2, price: 'any_price', like: 'handmade', no: 560 },
        { group: 2, price: 'under_25', like: 'stylish', no: 247 },
        { group: 2, price: 'under_25', like: 'handmade', no: 365 },
        { group: 2, price: '25_50', like: 'stylish', no: 68 },
        { group: 2, price: '25_50', like: 'handmade', no: 69 },
        { group: 2, price: '50_100', like: 'stylish', no: 39 },
        { group: 2, price: '50_100', like: 'handmade', no: 69 },
        { group: 2, price: 'over_100', like: 'stylish', no: 19 },
        { group: 2, price: 'over_100', like: 'handmade', no: 26 },
        { group: 3, price: 'any_price', like: 'stylish', no: 389 },
        { group: 3, price: 'any_price', like: 'handmade', no: 184 },
        { group: 3, price: 'under_25', like: 'stylish', no: 80 },
        { group: 3, price: 'under_25', like: 'handmade', no: 25 },
        { group: 3, price: '25_50', like: 'stylish', no: 128 },
        { group: 3, price: '25_50', like: 'handmade', no: 71 },
        { group: 3, price: '50_100', like: 'stylish', no: 159 },
        { group: 3, price: '50_100', like: 'handmade', no: 84 },
        { group: 3, price: 'over_100', like: 'stylish', no: 5 },
        { group: 3, price: 'over_100', like: 'handmade', no: 0 },
        { group: 4, price: 'any_price', like: 'stylish', no: 539 },
        { group: 4, price: 'any_price', like: 'handmade', no: 408 },
        { group: 4, price: 'under_25', like: 'stylish', no: 279 },
        { group: 4, price: 'under_25', like: 'handmade', no: 196 },
        { group: 4, price: '25_50', like: 'stylish', no: 120 },
        { group: 4, price: '25_50', like: 'handmade', no: 107 },
        { group: 4, price: '50_100', like: 'stylish', no: 114 },
        { group: 4, price: '50_100', like: 'handmade', no: 82 },
        { group: 4, price: 'over_100', like: 'stylish', no: 10 },
        { group: 4, price: 'over_100', like: 'handmade', no: 8 },
        { group: 5, price: 'any_price', like: 'stylish', no: 92 },
        { group: 5, price: 'any_price', like: 'handmade', no: 71 },
        { group: 5, price: 'under_25', like: 'stylish', no: 63 },
        { group: 5, price: 'under_25', like: 'handmade', no: 45 },
        { group: 5, price: '25_50', like: 'stylish', no: 16 },
        { group: 5, price: '25_50', like: 'handmade', no: 14 },
        { group: 5, price: '50_100', like: 'stylish', no: 12 },
        { group: 5, price: '50_100', like: 'handmade', no: 10 },
        { group: 5, price: 'over_100', like: 'stylish', no: 1 },
        { group: 5, price: 'over_100', like: 'handmade', no: 1 }
    ],
    groups: [
        {
            id: 1,
            name: 'Maistas ir g\u0117rimai',
            slug: 'maistas-ir-gerimai',
            created_at: '2021-04-21 05:30:09',
            updated_at: '2021-04-21 08:53:43',
            self_ids: '764'
        },
        {
            id: 2,
            name: 'Namai ir gyvenimas',
            slug: 'namai-ir-gyvenimas',
            created_at: '2021-04-21 05:30:18',
            updated_at: '2021-04-21 05:30:18',
            self_ids: ''
        },
        {
            id: 3,
            name: 'Drabu\u017eiai ir avalyn\u0117',
            slug: 'drabuziai-ir-avalyne',
            created_at: '2021-04-21 05:30:46',
            updated_at: '2021-04-21 05:30:46',
            self_ids: ''
        },
        {
            id: 4,
            name: 'Papuo\u0161alai ir aksesuarai',
            slug: 'papuosalai-ir-aksesuarai',
            created_at: '2021-04-21 05:30:52',
            updated_at: '2021-04-21 05:30:52',
            self_ids: ''
        },
        {
            id: 5,
            name: 'Pramogos ir \u017eaislai',
            slug: 'pramogos-ir-zaislai',
            created_at: '2021-04-21 05:30:59',
            updated_at: '2021-04-21 05:30:59',
            self_ids: ''
        }
    ]
}

export default personalization
